<template>
  <div>
    <section class="section auth-ui-section--has-margin-top auth-ui-section--is-narrow">
      <div class="container auth-ui-container--has-centered-content">
        <v-card :classes="'auth-ui-card--is-not-full-width'">
          <div slot="header-title">
            {{ $t('auth.emailChangedTitle') }}
          </div>
          <div slot="body">
            {{ $t('auth.emailChangedDescription') }}
            <!-- eslint-disable vue/html-self-closing -->
            <br />
            <div v-if="!emailChangeComplete">
              {{
                $t('auth.emailChangeInProcess')
              }}
            </div>
            <div v-else>
              {{
                $t('auth.emailChangeComplete')
              }}
              <br />
              <!-- eslint-enable vue/html-self-closing -->
              <a :href="previousPage">
                {{
                  $t('auth.goBackToPreviousPage')
                }}
              </a>
            </div>
          </div>
        </v-card>
      </div>
    </section>
  </div>
</template>

<script>
/* ============
 * Not Found Page
 * ============
 *
 * Shown when an external user has changed their email.
 */

import Request from '../../tools/Request';
import VCard from '../../components/Card.vue';

export default {
  name: 'GeneralMailChanged',

  components: {
    VCard,
  },

  data() {
    return {
      backendURL: process.env.VUE_APP_BACKEND_URL,
      emailChangeComplete: false,
      timer: null,
      newMail: null,
    };
  },

  computed: {
    previousPage() {
      const queryParameters = new URLSearchParams(window.location.search);
      return queryParameters.get('target') || process.env.VUE_APP_AFTER_SIGN_IN_URL;
    },
  },

  async mounted() {
    this.newMail = await this.getMailFromSession();
    this.timer = setInterval(() => {
      this.checkCounts();
    }, 5000);
  },

  methods: {
    async getMailFromSession() {
      try {
        const sessionResponse = await Request.submit(
          'GET',
          `${this.backendURL}/session`,
        );
        if (sessionResponse?.profile?.emails?.[0]?.address) {
          return sessionResponse.profile.emails[0].address;
        }
        return false;
      } catch (_exception) {
        return false;
      }
    },
    async checkCounts() {
      try {
        const countsResponse = await Request.submit(
          'POST',
          `${this.backendURL}/get_counts`,
          {
            email: this.newMail,
          },
        );
        if (countsResponse) {
          this.emailChangeComplete = true;
          clearInterval(this.timer);
          return true;
        }
        return false;
      } catch (_exception) {
        return false;
      }
    },
  },
};
</script>
